import { render, staticRenderFns } from "./smsTemplate.vue?vue&type=template&id=5e0a29d4&scoped=true&"
import script from "./smsTemplate.vue?vue&type=script&lang=js&"
export * from "./smsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./smsTemplate.vue?vue&type=style&index=0&id=5e0a29d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0a29d4",
  null
  
)

export default component.exports